import Vue from 'vue'
import SvgIcon from 'vue-svgicon'
import VuePortal from '@linusborg/vue-simple-portal'
import VeeValidate, { ValidationObserver, ValidationProvider } from "vee-validate";

import SocialLinksComponent from '@/components/SocialLinks'
import ComboboxComponent from '@/components/Combobox'
import CheckboxComponent from '@/components/Checkbox'
import DatepickerComponent from '@/components/DatePicker'
import TimePickerComponent from '@/components/TimePicker'
import OverlayComponent from '@/components/Overlay'
import MenuButtonComponent from '@/components/MenuButton'
import FileUploadComponent from '@/components/FileUpload'
import MultipleFileUploadComponent from '@/components/MultipleFileUpload'
import ThreadMessagesComponent from '@/components/ThreadMessages'
import ThreadsComponent from '@/components/Threads'
import SignatureComponent from '@/components/Signature'
import DialogComponent from "@/components/Dialog"
import LoadingComponent from "@/components/Loading"
import PageComponent from "@/components/Page"
import GroupComponent from "@/components/Group"
import FillinComponent from "@/components/Fillin"
import LotteryChoiceComponent from "@/components/LotteryChoice"
import MultiSelectListComponent from "@/components/MultiSelectList"
import CommentCardComponent from "@/components/CommentCard"

// Import all icons
import '../components/icons'

// Register SVG Icon
Vue.use(SvgIcon, {
  tagName: "svgicon",
  defaultWidth: '16px',
  defaultHeight: '16px',
  isOriginalDefault: true
});

// Register Additional Plugin Components
Vue.use(VuePortal, {
  name: "portal",
});

// Register Validation Plugin
Vue.use(VeeValidate);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// Register global components
Vue.component('social-links-component', SocialLinksComponent)
Vue.component('combobox-component', ComboboxComponent)
Vue.component('checkbox-component', CheckboxComponent)
Vue.component('datepicker-component', DatepickerComponent)
Vue.component('timepicker-component', TimePickerComponent)
Vue.component('overlay-component', OverlayComponent)
Vue.component('menu-button-component', MenuButtonComponent)
Vue.component('file-upload-component', FileUploadComponent)
Vue.component('multiple-file-upload-component', MultipleFileUploadComponent)
Vue.component('thread-messages-component', ThreadMessagesComponent)
Vue.component('threads-component', ThreadsComponent)
Vue.component('signature-component', SignatureComponent)
Vue.component('dialog-component', DialogComponent);
Vue.component('loading-component', LoadingComponent);
Vue.component('page-component', PageComponent);
Vue.component('group-component', GroupComponent);
Vue.component('fillin-component', FillinComponent);
Vue.component('lottery-choice-component', LotteryChoiceComponent);
Vue.component('multiselectlist-component', MultiSelectListComponent);
Vue.component('commentcard-component', CommentCardComponent);
